import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import MenuMinhaConta from "../MenuMinhaConta";
import PesquisaArtigo from "../PesquisaArtigo";

export default function PrimeiroAcesso() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/minha-conta-e-login">Minha Conta e Login</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Como realizar meu primeiro acesso?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuMinhaConta />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Como realizar meu primeiro acesso?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Minha Conta e Login</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Informações de acesso
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Após assinatura do contrato, você receberá um e-mail contendo
                  todas as instruções para a realização do primeiro acesso.
                </p>

                <figure>
                  <img
                    src="img/dados-de-acesso.png"
                    alt="excel"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </figure>

                <figcaption>E-mail: Dados de acesso</figcaption>

                <p>
                  Também será enviado um e-mail com o link para a definição da
                  senha.
                </p>

                <figure>
                  <img
                    src="img/definir-senha.png"
                    alt="excel"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </figure>

                <figcaption>E-mail: Definição de senha</figcaption>

                <p>
                  O link expira em 24 horas e a senha deve conter no mínimo:
                </p>

                <ul>
                  <li>8 caracteres</li>
                  <li>1 letra maiúscula</li>
                  <li>1 número</li>
                  <li>1 caractere especial</li>
                </ul>

                <p>
                  Para fazer o login, utilize o link enviado no corpo do e-mail
                  ou acesse o artigo<a> </a>
                  <a href="/como-fazer-login" target="blank">
                    Como fazer login?
                  </a>
                </p>

                <p>
                  Caso tenha dificuldade para acessar o link ou definir a senha,
                  entre em contato conosco.
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
